import React, {Component} from 'react';
import { connect } from 'react-redux';


import Addbox from "../../FeedContainer/Addbox";
import AddboxRight from "../../FeedContainer/AddboxRight";
import Detail from "./view";

class PromotionViewDetail extends Component {
    constructor(props) {
      super(props);
      this.state = {
        promotionId    : this.props.promotionId
  
      };
    }
    componentDidMount() {
      
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
     
    }

    
    UNSAFE_componentWillUpdate(){
      var scrollTop  = $(window).scrollTop(),
      elementOffset  = $('.content_block').offset().top,
      distance       = (elementOffset - scrollTop);
      if(distance > 0){
        $('.content_block').css('padding','0 0px 0px 55px');
      }
    }
    render() {
      return (
       
          <div className="content_area">
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
               <Addbox/>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area">
               {(this.props.currentUserDetails.user.membership != "GOLD") ?
                <AddboxRight />
                : null 
               }
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 post_area">
                <div className="row">
                  <Detail urlImageId={this.state.urlImageId}/> 
                </div>
            </div>
          </div>
       
      );
    }
}

const mapStateToProps = state => {
 
  return {
    listOfFeed         : state.listfeed,
    currentUserDetails : state.login,
    
  }
}



export default connect(
  mapStateToProps
)(PromotionViewDetail);

